import { useEffect } from 'react';
import {
  Avatar,
  FormControl,
  FormHelperText,
  InputBaseComponentProps,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { AccordionArrowPurple } from 'Images';

interface IControlledSelectInput {
  label: string;
  options: string[];
  optionsValues?: string[];
  value: string;
  setValue: (option: string) => void;
  hide?: boolean;
  hideIcon?: boolean;
  sx?: SxProps;
  inputSx?: SxProps;
  errorMsg?: string;
  formControlProps?: any;
  defaultValue?: string;
  inputProps?: InputBaseComponentProps;
}

export const ControlledSelectInput = ({
  sx,
  inputSx,
  label,
  options,
  optionsValues,
  value,
  setValue,
  hide = false,
  hideIcon,
  errorMsg,
  formControlProps,
  defaultValue,
  inputProps,
}: IControlledSelectInput) => {
  const isDesktop = useIsDesktop();

  useEffect(() => {
    if (defaultValue !== undefined) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <FormControl
      error={errorMsg ? true : false}
      style={{
        width: '400px',
        maxWidth: '100%',
        visibility: hide ? 'hidden' : 'visible',
      }}
      sx={{
        '& label[data-shrink="false"]': { mt: isDesktop ? '-4px' : '-7px' },
        ...sx,
      }}
      {...formControlProps}
    >
      <InputLabel id={`${value}-select-label`} sx={{}}>
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={(event: SelectChangeEvent) => setValue(event.target.value)}
        id={`${value}-select`}
        labelId={`${value}-select-label`}
        label={label}
        sx={{
          height: isDesktop ? '48px' : '42px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(23, 82, 175, 0.2)',
            borderRadius: '6px',
            borderWidth: '1px !important',
          },
        }}
        inputProps={{
          sx: {
            ...inputSx,
          },
          ...inputProps,
        }}
        MenuProps={{
          PaperProps: { sx: { borderRadius: '6px', maxHeight: '244px' } },
          MenuListProps: {
            sx: {
              p: 0,
              '& .Mui-selected': {
                backgroundColor: '#F2F9FF !important',
                filter: 'none',
                fontWeight: 700,
              },
            },
          },
        }}
        IconComponent={(props) =>
          !hideIcon ? (
            <Avatar
              {...props}
              src={AccordionArrowPurple}
              alt=''
              sx={{
                width: '22px',
                m: '0 12px',
                top: '6px !important',
              }}
            />
          ) : null
        }
      >
        {options.map((option, index) => {
          return (
            <MenuItem
              key={index}
              sx={{
                fontWeight: 400,
                ':hover': {
                  backgroundColor: '#F2F9FF',
                  fontWeight: 700,
                },
              }}
              value={optionsValues ? optionsValues[index] : option}
            >
              {option}
            </MenuItem>
          );
        })}
      </Select>
      {errorMsg && (
        <FormHelperText sx={{ color: 'error.main' }}>{errorMsg}</FormHelperText>
      )}
    </FormControl>
  );
};
